(() => {
    if (window.cloCardImagesInitialized || !window.ResizeObserver || !window.lazySizes) return;
    window.cloCardImagesInitialized = true;

    const selector = 'img[data-clo-card-image][data-sizes="auto"]';
    const observed = new Set();
    const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach(({ target: image }) => {
            if (!image.isConnected || !image.offsetWidth || !image.hasAttribute('srcset')) return;
            window.lazySizes.autoSizer.updateElem(image, false, image.offsetWidth);
        });
    });

    const eachImage = (root, callback) => {
        if (root.nodeType !== 1) return;
        const images = root.matches(selector) ? [root] : root.querySelectorAll(selector);
        images.forEach(callback);
    };
    const observe = (image) => {
        if (observed.has(image)) return;
        observed.add(image);
        resizeObserver.observe(image);
    };
    const unobserve = (image) => {
        if (image.isConnected) return;
        resizeObserver.unobserve(image);
        observed.delete(image);
    };

    eachImage(document.documentElement, observe);

    new MutationObserver((records) => {
        records.forEach(({ addedNodes, removedNodes }) => {
            addedNodes.forEach((node) => eachImage(node, observe));
            removedNodes.forEach((node) => eachImage(node, unobserve));
        });
    }).observe(document.documentElement, { childList: true, subtree: true });
})();
